export enum DateFormat {
    HiddenYear="HiddenYear",
    HiddenMonthNYear="HiddenMonthNYear",
    NothingHidden="NothingHidden"
}
